import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { fmtDate } from "@/lib/api";

export default function ThisWeek({ pid, refreshKey }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/projects/${pid}/programme/this-week`).then(r => setD(r.data)); }, [pid, refreshKey]);
  if (!d) return null;
  async function copy() {
    try { await navigator.clipboard.writeText(d.text); }
    catch {
      const t = document.createElement("textarea"); t.value = d.text; document.body.appendChild(t); t.select();
      document.execCommand("copy"); t.remove();
    }
    toast.success("This week's programme copied");
  }
  return (
    <div className="card space-y-2" data-testid="programme-this-week">
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <h3 className="text-silver">This week ({fmtDate(d.week_start)} to {fmtDate(d.week_end)})</h3>
        <button className="btn-ghost text-sm" onClick={copy} data-testid="programme-copy-week">Copy as text</button>
      </div>
      {d.items.length === 0 && <div className="text-sm opacity-60">No programme tasks start or finish this week.</div>}
      {d.items.map(i => (
        <div key={i.id} className="text-sm flex flex-wrap gap-x-2" data-testid={`this-week-${i.id}`}>
          <span>{i.done ? "✓ " : ""}{i.name}</span>
          {i.trade && <span className="opacity-60">({i.trade})</span>}
          <span className="opacity-70">{i.milestone ? `Milestone ${fmtDate(i.start_date)}` : `${fmtDate(i.start_date)} to ${fmtDate(i.end_date)}`}</span>
        </div>
      ))}
    </div>
  );
}
